"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SFT_TO_EXPECTED_WEATHER_MAP = exports.SFT_WEATHER_CONDITIONS = exports.EXPECTED_WEATHER_CONDITIONS = exports.DEFAULT_WEATHER_CONDITION = void 0;
exports.DEFAULT_WEATHER_CONDITION = 'Sunny';
exports.EXPECTED_WEATHER_CONDITIONS = ['Sunny', 'Partly Cloudy', 'Cloudy', 'Rainy', 'Windy'];
exports.SFT_WEATHER_CONDITIONS = {
    Blgsno: 'Blowing Snow',
    Blzzrd: 'Blizzard',
    Clear: 'Clear',
    Cloudy: 'Cloudy',
    Drzl: 'Drizzle',
    Dust: 'Dust',
    Fair: 'Fair',
    Flrrys: 'Snow Flurries',
    Foggy: 'Foggy',
    Fzdrzl: 'Freezing Drizzle',
    Fzrain: 'Freezing Rain',
    Haze: 'Haze',
    Mocldy: 'Mostly Cloudy',
    Ptcldy: 'Partly Cloudy',
    Rain: 'Rain',
    Rnsnow: 'Rain/Snow',
    Shwrs: 'Showers',
    Sleet: 'Sleet',
    Smoke: 'Smoke',
    Snoshwr: 'Snow Showers',
    Snow: 'Snow',
    Sunny: 'Sunny',
    Tstrms: 'Thunderstorms',
    Vrycld: 'Very Cold',
    Vryhot: 'Very Hot',
    Windy: 'Windy',
};
exports.SFT_TO_EXPECTED_WEATHER_MAP = {
    Clear: 'Sunny',
    Sunny: 'Sunny',
    Fair: 'Sunny',
    Vryhot: 'Sunny',
    Vrycld: 'Sunny',
    Ptcldy: 'Partly Cloudy',
    Mocldy: 'Cloudy',
    Cloudy: 'Cloudy',
    Foggy: 'Cloudy',
    Haze: 'Cloudy',
    Smoke: 'Cloudy',
    Drzl: 'Cloudy',
    Fzdrzl: 'Rainy',
    Rain: 'Rainy',
    Shwrs: 'Rainy',
    Fzrain: 'Rainy',
    Sleet: 'Rainy',
    Tstrms: 'Rainy',
    Rnsnow: 'Rainy',
    Snow: 'Rainy',
    Snoshwr: 'Rainy',
    Flrrys: 'Rainy',
    Blgsno: 'Rainy',
    Blzzrd: 'Rainy',
    Windy: 'Windy',
    Dust: 'Windy',
};
